/* file description */
import { useMemo, useEffect, useRef, useState } from 'react';
import { UseSetFilter } from './type';
import { COLUMN_FROM } from '../../../effects/consts';
import { getModuleRecordListCache } from '@/common/asset-apis/assetModel';
import { cloneDeep } from 'lodash';

export const useSetFilter: UseSetFilter = ({ field, form, config, columnFrom, setShowLabel, setOptionList, onChange, fieldValue, rowsData, moduleInfo, dataKey, treeId, API, isMulti }) => {
  const { dispatchEvent, destroyEvent } = config.metaStore || {};
  const [filterList, setfilterList] = useState({});
  const { parentName, parentField, parentList } = field?.options || {};
  const firstUpdate = useRef(true);
  const filterRef = useRef({});
  // let parentValue: string | undefined;
  // const filterList: Record<any, any> = {};
  // if (columnFrom === COLUMN_FROM.TABLE) {
  //   if (rowsData?.[config.rowIndex]) {
  //     if (parentList?.length > 0) {
  //       parentList?.forEach((item: any) => {
  //         filterList[item.parentListKey] = rowsData?.[config.rowIndex]?.[item.parentListValue];
  //       });
  //     }
  //     if (parentField && parentName) {
  //       filterList[parentName] = rowsData?.[config.rowIndex]?.[parentField];
  //     }
  //     // parentValue = form.getFieldsValue()[config.rowIndex][field?.options?.parentField];
  //   }
  // } else {
  //   if (parentList?.length > 0) {
  //     parentList?.forEach((item: any) => {
  //       filterList[item.parentListKey] = form.getFieldsValue()?.[item.parentListValue];
  //     });
  //   }
  //   if (parentField && parentName) {
  //     filterList[parentName] = form.getFieldsValue()?.[parentField];
  //   }
  //   // parentValue = form.getFieldsValue()[field?.options?.parentField];
  // }
  useEffect(() => {
    if (columnFrom === COLUMN_FROM.TABLE) {
      if (rowsData?.[config.rowIndex]) {
        if (parentList?.length > 0) {
          parentList?.forEach((item: any) => {
            filterRef.current = { ...filterRef.current, [item.parentListKey]: rowsData?.[config.rowIndex]?.[item.parentListValue] };
          });
        }
        if (parentField && parentName) {
          filterRef.current = { ...filterRef.current, [parentName]: rowsData?.[config.rowIndex]?.[parentField] };
        }
      }
    }
    if (columnFrom === COLUMN_FROM.FORM) {
      if (parentList?.length > 0) {
        parentList?.forEach((item: any) => {
          filterRef.current = { ...filterRef.current, [item.parentListKey]: config.formValue?.[item.parentListValue] };
        });
      }
      if (parentField && parentName) {
        filterRef.current = { ...filterRef.current, [parentName]: config.formValue?.[parentField] };
      }
    }

    const idList: any[] = [];
    if (parentList?.length > 0) {
      parentList?.forEach((item: any) => {
        const events = [{
          code: field.name,
          name: field.label,
          touchConfig: 'change',
          actionType: 'callback',
          moduleName: moduleInfo.handle,
          fieldName: item.parentListValue,
          rowIndex: config.rowIndex,
          fun: (value: any) => {
            filterRef.current = { ...filterRef.current, [item.parentListKey]: value };
            setfilterList({ ...filterRef.current, [item.parentListKey]: value });
            handleFilterChange();
          },
        }];
        const ids = dispatchEvent?.(events);
        idList.push(ids);
      });
    }
    if (parentField && parentName) {
      const events = [{
        code: field.name,
        name: field.label,
        touchConfig: 'change',
        actionType: 'callback',
        moduleName: moduleInfo?.handle,
        fieldName: parentField,
        rowIndex: config.rowIndex,
        fun: (value: any) => {
          filterRef.current = { ...filterRef.current, [parentName]: value };
          setfilterList({ ...filterRef.current, [parentName]: value });
          handleFilterChange();
        },
      }];
      const ids = dispatchEvent?.(events);
      idList.push(ids);
    }
    return () => {
      idList?.forEach((ids: any) => {
        destroyEvent?.(ids);
      });
    };
  }, []);

  const handleFilterChange = () => {
    onChange && onChange(null);
    const { isFilter, dataType, prefilter } = field?.options || {};
    let filter = '';
    if (isFilter) {
      filter = dataType || prefilter || '';
    }
    if (Object.keys(filterRef.current)?.length > 0) {
      const pass = Object.keys(filterRef.current).every((key: string) => filterRef.current[key]);
      if (pass) {
        let changeFilter = '';
        Object.keys(filterRef.current).forEach((key: string) => {
          changeFilter = changeFilter ? `${changeFilter} AND ${key} = '${filterRef.current[key]}'` : `${key} = '${filterRef.current[key]}'`;
        });
        filter = filter ? `(${filter}) AND (${changeFilter})` : `(${changeFilter})`;
      }
    }
    const params: Record<any, any> = {
      moduleID: dataKey,
      namespaceID: treeId,
      limit: 3000,
      filter,
    };
    getModuleRecordListCache(API?.FetchAPI, treeId, dataKey, params).then((res: any) => {
      const { set = [] } = res || {};
      if (set?.length === 1 && !isMulti) {
        onChange?.(set[0]?.values?.find((item: any) => item.name === field?.options?.value)?.value);
      }
    });
  };

  // 父字段值变化清空选中
  // useEffect(() => {
  //   setOptionList([]);
  //   if (firstUpdate.current) {
  //     setTimeout(() => {
  //       firstUpdate.current = false;
  //     }, 1000);
  //   } else {
  //     fieldValue && onChange && onChange(null);
  //   }
  //   // setShowLabel('')
  // }, [JSON.stringify(filterRef.current)]);

  return useMemo(() => {
    const { isFilter, dataType, prefilter } = field?.options || {};
    let filter = '';
    // 配置了预过滤
    if (isFilter) {
      // 预过滤优先使用dataType
      filter = dataType || prefilter || '';
    }
    // 配置了父级过滤
    // if (parentName && parentField && parentValue) {
    //   filter = filter ? `(${filter}) AND ${parentName} = '${parentValue}'` : `${parentName} = '${parentValue}'`;
    // }
    if (Object.keys(filterRef.current)?.length > 0) {
      const pass = Object.keys(filterRef.current).every((key: string) => filterRef.current[key]);
      if (pass) {
        let changeFilter = '';
        Object.keys(filterRef.current).forEach((key: string) => {
          changeFilter = changeFilter ? `${changeFilter} AND ${key} = '${filterRef.current[key]}'` : `${key} = '${filterRef.current[key]}'`;
        });
        filter = filter ? `(${filter}) AND (${changeFilter})` : `(${changeFilter})`;
      }
    }
    return {
      filter,
    };
  }, [JSON.stringify(filterRef.current)]);
};
